import { Link } from "react-router-dom";
import type { TopicItem } from "@/mocks/topics";

export default function TopicRow({ topic, index }: { topic: TopicItem; index?: number }) {
  return (
    <Link
      to={`/community-detail/${topic.id}`}
      className="group flex items-start gap-3 border-b border-background-200/80 px-1 py-4 last:border-b-0 transition-colors hover:bg-background-100/60"
    >
      {typeof index === "number" ? (
        <span
          className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded text-[11px] ${
            index < 3
              ? "bg-primary-500 text-background-50"
              : "bg-background-200 text-foreground-500"
          }`}
        >
          {index + 1}
        </span>
      ) : (
        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded bg-background-200 text-[11px] text-accent-500">
          <i className="ri-chat-3-line"></i>
        </span>
      )}
      <div className="min-w-0 flex-1">
        <h3 className="truncate text-[13.5px] font-medium text-foreground-900 transition-colors group-hover:text-accent-500">
          {topic.title}
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line"></i>
            {topic.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-1-line"></i>
            {topic.replyCount} 回复
          </span>
          <span className="hidden sm:flex items-center gap-1">
            <i className="ri-team-line"></i>
            {topic.participantCount} 参与
          </span>
        </div>
      </div>
      <i className="ri-arrow-right-s-line mt-1 shrink-0 text-foreground-600 transition-transform group-hover:translate-x-0.5 group-hover:text-accent-500"></i>
    </Link>
  );
}